import React, { Component } from 'react';
import data from '../../assets/json/about.json';

export default class About extends Component {
  componentDidMount() {
    if(this.props.get) {
      this.props.get('about');
    }
  }

  render() {
    return(
      <div className="about">
        <div className="about-card-wrapper">
          <div className="about-card">
            <h2 className="title">About</h2>
            {
              data.bio.map((content, index) => (
                <p key={index}>{content}</p>
              ))
            }
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/home/About.js